import { attr } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/mlp-module';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  invalidMessage: validator('presence', true),
});

export const settings = {
  copyableOptions: { ignoreAttributes: ['contentItem', 'modelIds'] },
};

export default class MlpZatapModel extends Model.extend(Validations) {
  @attr('array') modelIds;
  @attr('string') invalidMessage;
}
